import { HeaderBox, Pad, PadBox } from 'component/basics';
import { colorTextPrimary } from 'component/color';
import { CommentPageTopWidgets } from 'component/comment';
import { TabbedView } from 'component/tabs';
import { Heading } from 'component/text';
import React, { useState } from 'react';
import { View } from 'react-native';
import { Catcher } from 'system/catcher';
import type { Datastore } from 'util/datastore';
import { useConfig } from 'util/features';
import type { TLabel } from 'util/stdtypes';

export type QuestionTab = {
    key: string;
    label: TLabel;
    component: React.ComponentType;
    onShow?: (datastore: Datastore) => void;
};

function HeaderTopWidgets() {
    type HeaderConfig = { headerTopLeftWidgets?: React.ComponentType[] };
    const { headerTopLeftWidgets } = useConfig<HeaderConfig>();
    if (headerTopLeftWidgets && headerTopLeftWidgets.length > 0) {
        return (
            <>
                <Pad size={12} />
                {headerTopLeftWidgets.map((Widget, i) => (
                    <Widget key={i} />
                ))}
                <Pad size={32} />
            </>
        );
    }
    return null;
}

export type QuestionProps = {
    name: string;
    topBanners?: React.ComponentType[];
    headerAboveInputWidgets?: React.ComponentType[];
    composerPreview?: React.ComponentType | null;
    headerBelowInputWidgets?: React.ComponentType[];
    bottomRecircWidgets?: React.ComponentType[];
    tabs: QuestionTab[];
};

export function Question({
    name,
    topBanners,
    headerAboveInputWidgets,
    composerPreview,
    headerBelowInputWidgets,
    bottomRecircWidgets,
    tabs,
}: QuestionProps) {
    const [selectedTabKey, setSelectedTabKey] = useState(tabs[0].key);
    return (
        <>
            {topBanners?.map((Banner, i) => (
                <Banner key={i} />
            ))}
            <View style={{ zIndex: 1 }}>
                <Catcher>
                    <HeaderBox>
                        <HeaderTopWidgets />
                        <Heading color={colorTextPrimary} text={name} type='large' weight='medium' />
                        {headerAboveInputWidgets?.map((Widget, i) => (
                            <Widget key={i} />
                        ))}
                        <Pad size={32} />
                        {composerPreview && React.createElement(composerPreview)}
                        {headerBelowInputWidgets?.map((Widget, i) => (
                            <Widget key={i} />
                        ))}
                        <Pad size={12} />
                    </HeaderBox>
                </Catcher>
            </View>
            <PadBox horiz={20}>
                <CommentPageTopWidgets />
                <Pad size={32} />
                <TabbedView onSelectTab={setSelectedTabKey} selectedTabKey={selectedTabKey} tabs={tabs} />
            </PadBox>
            {bottomRecircWidgets?.map((Widget, i) => (
                <Widget key={i} />
            ))}
        </>
    );
}
